import { createSelector } from 'reselect'
import { SessionPermission, TabPanel } from '@tabeeb/enums'
import { hasSessionPermission } from '@tabeeb/modules/permissions/selectors'
import {
  getIsContentReviewingSettingEnabled,
  getIsContentSharingSettingEnabled,
  getIsContentsLinkingSettingEnabled,
  getIsMergeForReviewEnabled,
} from '@tabeeb/modules/appConfigState/selectors'
import { getNavbarCurrentBottomPanel } from '@tabeeb/modules/customVideo/selectors'
import { getReviewsList } from '@tabeeb/modules/contentReviews/selectors'
import { getContentReviewDestinationOptions } from '@tabeeb/modules/sessionsPage/selectors/contentSharings'

export const getLinkedContentsList = (state) => state.contentSharings.linkedContents.list
export const getContentSharingDialogState = (state) => state.contentSharings.contentSharingDialogState
export const getContentSharingPages = (state) => state.contentSharings.contentSharingDialogState.pages
export const getContentSharingForms = (state) => state.contentSharings.contentSharingDialogState.contentForms
export const getContentSharingTenant = (state) => state.contentSharings.contentSharingDialogState.tenant
export const getUserSearchState = (state) => state.contentSharings.userSearch
export const getContentSearchState = (state) => state.contentSharings.contentSearch
export const getHasShareContentPermission = (state) => hasSessionPermission(state, SessionPermission.ExportSession)
export const getIsSelectedPagesForMergingOpen = (state) => state.contentSharings.selectedPagesForMerging.isOpen

export const getIsContentSharingEnabled = createSelector(
  [getIsContentSharingSettingEnabled, getHasShareContentPermission],
  (isSettingEnabled, hasPermission) => {
    return isSettingEnabled && hasPermission
  }
)

export const getIsContentReviewingEnabled = createSelector(
  [getIsContentReviewingSettingEnabled, getIsMergeForReviewEnabled, getHasShareContentPermission],
  (isReviewSettingEnabled, isMergeReviewSettingEnabled, hasPermission) => {
    return (isReviewSettingEnabled || isMergeReviewSettingEnabled) && hasPermission
  }
)

export const getIsContentLinkingEnabled = createSelector(
  [getIsContentsLinkingSettingEnabled, getHasShareContentPermission],
  (isSettingEnabled, hasPermission) => {
    return isSettingEnabled && hasPermission
  }
)

export const getIsSelectedPagesForMergingNavbarTabActive = createSelector(
  [getIsSelectedPagesForMergingOpen, getNavbarCurrentBottomPanel],
  (isOpen, currentBottomTab) => {
    return isOpen && currentBottomTab?.name === TabPanel.LinkedContentsSelectedPages
  }
)

export const getContentReviewDefaultType = createSelector(
  [getContentReviewDestinationOptions],
  (contentReviewTypes) => {
    if (contentReviewTypes.length === 0) {
      return null
    }

    return contentReviewTypes[0].type
  }
)

export const getReviewByContentSharingId = createSelector(
  [getReviewsList, (_, { contentSharingId }) => contentSharingId],
  (reviewsList, contentSharingId) => {
    return reviewsList.find((r) => r.Id === contentSharingId)
  }
)
